import { useSearchParams } from "react-router-dom";

import { EditHistoryPage, type HistoryTab } from "@/features/mentions/EditHistoryPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

/** O histórico de edições de classificação da empresa (2026-10-18).
 *  `?aba=lotes` abre a aba de lotes; `?lote=N` filtra as alterações por
 *  um lote de edição. */
export function EditHistoryRoute() {
  const { token, profile, openMention, mentionChange } = useAppShell();
  const company = useRequireCompany();
  const [params, setParams] = useSearchParams();

  if (!company) return null;
  // Mesmo papel que a API exige pra ler a trilha da empresa.
  if (!hasRoleAtLeast(profile, "administrator")) {
    return <ApiState kind="error">O histórico de edições é de Administrador ou acima.</ApiState>;
  }

  const tab: HistoryTab = params.get("aba") === "lotes" ? "batches" : "changes";
  const rawBatch = Number(params.get("lote"));
  const bulkEditId = Number.isInteger(rawBatch) && rawBatch > 0 ? rawBatch : null;

  return (
    <EditHistoryPage
      token={token}
      companyId={company.id}
      openMention={openMention}
      mentionChange={mentionChange}
      tab={tab}
      bulkEditId={bulkEditId}
      onViewChange={view => {
        const query = new URLSearchParams(params);
        if (view.tab === "batches") query.set("aba", "lotes");
        else query.delete("aba");
        if (view.bulkEditId !== null) query.set("lote", String(view.bulkEditId));
        else query.delete("lote");
        setParams(query, { replace: true });
      }}
    />
  );
}
